import { withProps } from 'recompose';

export default withProps({
  baseUrl: '/kiosk',
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithKioskBaseUrl.js